export function initDossierObject() {
    return (
        {
            id: null,
            tax_date: null,
            eco_check: false,
            nego_check: false,
            status: "",
            customer_id: null,
            kva_power: null,
            structure_datas: []
        }
    )
}

export function buildDossierFormDataBuilder(dossier) {    
    const formData = new FormData();
    
    if (dossier.id)
        formData.append('dossier[id]', dossier.id);

    formData.append('dossier[eco_check]', dossier.eco_check); 
    formData.append('dossier[nego_check]', dossier.nego_check);

    const customer_id = dossier.customer?.id ? dossier.customer.id : dossier.customer_id;
    formData.append('dossier[customer_id]', customer_id);
    
    dossier.structure_datas.forEach((st_data, index) => {
        const key = 'dossier[structure_datas_attributes][]';

        if (st_data.id)
            formData.append(`${key}[id]`, st_data.id);

        if (st_data.kva_power)
            formData.append(`${key}[kva_power]`,    st_data.kva_power);

        formData.append(`${key}[structure_id]`, st_data.structure_id);
        formData.append(`${key}[added_value]`,  st_data.added_value);
        
        formData.append(`${key}[electric_index]`, st_data.electric_index ?? "");

        if (st_data.eligibility_value)
            formData.append(`${key}[eligibility_value]`, st_data.eligibility_value);
    });

    return formData;
}